import { $3l5vvh8yg0ier as $ } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.l4u_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.i4u_1;
    if (index >= interceptors.q2()) {
      $this.m4u();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.l4u_1 = index + 1 | 0;
    yield* $(executeInterceptor($this, $this.k4u_1, $completion), $completion);
  }
   while (true);
  return $this.k4u_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.i4u_1 = interceptors;
        this.j4u_1 = coroutineContext;
        this.k4u_1 = subject;
        this.l4u_1 = 0;
      }
      ww() {
        return this.j4u_1;
      }
      n4u() {
        return this.k4u_1;
      }
      m4u() {
        this.l4u_1 = -1;
      }
      *o4u(subject, $completion) {
        this.k4u_1 = subject;
        return yield* this.p4u($completion);
      }
      *p4u($completion) {
        var index = this.l4u_1;
        if (index < 0)
          return this.k4u_1;
        if (index >= this.i4u_1.q2()) {
          this.m4u();
          return this.k4u_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *q4u(initial, $completion) {
        this.l4u_1 = 0;
        this.k4u_1 = initial;
        return yield* this.p4u($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
